import { render, staticRenderFns } from "./AsAMasterPageMenu.vue?vue&type=template&id=467f7a1a&scoped=true"
import script from "./AsAMasterPageMenu.vue?vue&type=script&lang=js"
export * from "./AsAMasterPageMenu.vue?vue&type=script&lang=js"
import style0 from "./AsAMasterPageMenu.vue?vue&type=style&index=0&id=467f7a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f7a1a",
  null
  
)

export default component.exports